var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"container"}},[_c('div',{staticClass:"row"},[_c('navbar'),_vm._v(" "),_c('router-view',{attrs:{"loggedIn":_vm.loggedIn}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('footer-section',{staticClass:"hidden-xs"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7d4fc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 230
// module chunks = 1